import { Stack, Typography } from "@mui/material";
import { InfoGroup } from "Components/Contact/InfoGroup";
import { Resources, useResource } from "Translations/Resources";
import { AccessRoleCodes, type AccessRoleCode } from "Models/AccessRoleCodes";

const RESOURCES = Resources.Pages.Content.Contact;

type Props = {
  userRole: AccessRoleCode;
};

export const CompanyInfo = ({ userRole }: Props) => {
  const { t } = useResource();

  if (userRole === AccessRoleCodes.Hunter) {
    return <HunterCompanyInfo />;
  }

  return (
    <InfoGroup title={t(RESOURCES.CompanyInfo.title)}>
      {t(RESOURCES.CompanyInfo.description)}
      <br />
      {t(RESOURCES.CompanyInfo.CompanyNumber)}
      <br />
      {t(RESOURCES.CompanyInfo.TaxNumber)}
      <br />
      {t(RESOURCES.CompanyInfo.CompanyAddress)}
      <br />
    </InfoGroup>
  );
};

const HunterCompanyInfo = () => {
  const { t } = useResource();

  return (
    <InfoGroup title={t(RESOURCES.HunterCompanyInfo.Title)}>
      <Stack>
        <Typography>{t(RESOURCES.HunterCompanyInfo.CompanyName)}</Typography>
        <Typography>
          {t(RESOURCES.HunterCompanyInfo.CompanyInfoLine1)}
        </Typography>
        <Typography>
          {t(RESOURCES.HunterCompanyInfo.CompanyInfoLine2)}
        </Typography>
        <Typography>
          {t(RESOURCES.HunterCompanyInfo.CompanyInfoLine3)}
        </Typography>
      </Stack>
    </InfoGroup>
  );
};
